const development_tenant = {
    notification: 'Vous êtes en mode développement',
};
export default Object.freeze(development_tenant);
